
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        size: {
            type: String as PropType<'small' | 'medium' | 'big'>,
            default: 'medium'
        },
        color: {
            type: String as PropType<'gray' | 'white' | 'transparent-blue'>,
            default: 'gray'
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    }
})
